import React from 'react';

import * as T from './interfaces';
import * as S from './styles';

export const Status = ({ id, children, status }: T.IStatus) => (
  <S.Status id={`status@${id}`} data-testid={`status@${id}`} status={status}>
    {children}
  </S.Status>
);
